import React from 'react';
import { useRippleEffect } from '../hooks/useRippleEffect';
import './Products.css';

const products = [
  {
    name: "Spott-on Professional",
    description: "For Small Enterprises",
    features: ["100 queries per month", "Free trial of 7 queries", "1 User Licence"],
    badge: null
  },
  {
    name: "Spott-on Elite",
    description: "For Medium Enterprises",
    features: ["700 queries per month", "Free trial of 7 queries", "3 User Licences"],
    badge: "Most Popular"
  },
  {
    name: "Spott-on Enterprise",
    description: "For Large Enterprises",
    features: ["2000 queries per month", "Free trial of 7 queries", "7 User Licences", "Phone Support"],
    badge: null
  }
];

export const Products: React.FC = () => {
  const { ripples, createRipple } = useRippleEffect();

  const handleScheduleDemo = () => {
    // Navigate to contact section
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="products" className="products" onClick={createRipple}>
      <div className="products-container">
        <div className="products-header">
          <h2 className="section-title">
            Choose Your
            <span className="title-highlight"> <span className="spotton-brand-text">Spott-on</span> Subscription Plan</span>
          </h2>
          <p className="section-description">
            From small teams to enterprise organizations, we have the perfect <span className="spotton-brand-text">Spott-on</span> subscription plan 
            to transform your business operations.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product, index) => (
            <div 
              key={index} 
              className={`product-card ${product.badge === "Most Popular" ? 'featured' : ''}`}
            >
              {product.badge && (
                <div className="product-badge">{product.badge}</div>
              )}
              
              <div className="product-header">
                <h3 className="product-name">
                  <span className="spotton-brand">
                    <span className="letter-s">S</span>
                    <span className="letter-p">p</span>
                    <span className="letter-o1">o</span>
                    <span className="letter-t1">t</span>
                    <span className="letter-t2">t</span>
                    <span className="letter-hyphen">-</span>
                    <span className="letter-o2">o</span>
                    <span className="letter-n">n</span>
                  </span>
                  <span className="product-variant" style={{ color: '#1a2332' }}>
                    {product.name.replace('Spott-on ', '')}
                  </span>
                </h3>
                <p className="product-description">{product.description}</p>
              </div>

              <ul className="product-features">
                {product.features.map((feature, idx) => (
                  <li key={idx} className="feature-item">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path 
                        d="M6 8l2 2 4-4" 
                        stroke="#3ab7c3" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="product-actions">
                <button className="btn-product-primary" onClick={handleScheduleDemo} style={{ cursor: 'pointer' }}>
                  Schedule Demo
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Ripple effects */}
      {ripples.map(ripple => (
        <div
          key={ripple.id}
          className="section-ripple"
          style={{
            left: ripple.x,
            top: ripple.y,
          }}
        >
          <div className="ripple-ring ring-1"></div>
          <div className="ripple-ring ring-2"></div>
          <div className="ripple-ring ring-3"></div>
        </div>
      ))}
    </section>
  );
};